var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5658 21.1622H92.4342V103.838H32.5658V21.1622Z",
    fill: "#FD882F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2894 19.7368H96.7105V22.5877H28.2894V19.7368Z",
    fill: "#FD882F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2894 25.4386H96.7105V28.2895H28.2894V25.4386Z",
    fill: "#FD882F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2894 51.0964H96.7105V53.9473H28.2894V51.0964Z",
    fill: "#FD882F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2894 76.7544H96.7105V79.6053H28.2894V76.7544Z",
    fill: "#FD882F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.715 103.838H24.0132L21.1624 93.8596H32.5659L29.715 103.838Z",
    fill: "#DEE1E3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5658 75.329C32.5665 74.3128 32.2902 73.3161 31.7661 72.4454C31.2455 71.5983 31.2413 70.5313 31.755 69.6801C32.6883 68.1252 32.8233 66.2188 32.1197 64.5484C31.4153 62.8772 29.9558 61.6432 28.1914 61.2256C26.4931 60.8226 24.7036 61.2186 23.3339 62.3002C21.9641 63.3819 21.1637 65.0307 21.1623 66.7763C21.1616 67.7918 21.4379 68.7878 21.9606 69.6585C22.4806 70.5153 22.4806 71.59 21.9606 72.4468C20.895 74.2209 20.895 76.4384 21.9606 78.2125C22.4806 79.0596 22.4854 80.1266 21.9718 80.9778C21.0384 82.5327 20.9034 84.4391 21.6071 86.1095C22.3114 87.7807 23.771 89.0147 25.5354 89.4323C27.2343 89.836 29.0238 89.44 30.3943 88.3584C31.764 87.2767 32.5644 85.6272 32.5658 83.8816C32.5665 82.8661 32.2902 81.8701 31.7675 80.9994C31.2476 80.1426 31.2476 79.0679 31.7675 78.2111C32.2902 77.3404 32.5665 76.3444 32.5658 75.329Z",
    fill: "#88B337"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4386 66.7764H28.2895V93.8597H25.4386V66.7764Z",
    fill: "#A3603E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.987 103.838H95.2851L92.4342 93.8596H103.838L100.987 103.838Z",
    fill: "#DEE1E3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M103.838 75.329C103.838 74.3128 103.562 73.3161 103.038 72.4454C102.517 71.5983 102.513 70.5313 103.027 69.6801C103.96 68.1252 104.095 66.2188 103.392 64.5484C102.687 62.8772 101.228 61.6432 99.4633 61.2256C97.765 60.8226 95.9756 61.2186 94.6058 62.3002C93.236 63.3819 92.4356 65.0307 92.4342 66.7763C92.4335 67.7918 92.7098 68.7878 93.2326 69.6585C93.7525 70.5153 93.7525 71.59 93.2326 72.4468C92.167 74.2209 92.167 76.4384 93.2326 78.2125C93.7525 79.0596 93.7574 80.1266 93.2437 80.9778C92.3103 82.5327 92.1753 84.4391 92.879 86.1095C93.5833 87.7807 95.0429 89.0147 96.8073 89.4323C98.5063 89.836 100.296 89.44 101.666 88.3584C103.036 87.2767 103.836 85.6272 103.838 83.8816C103.838 82.8661 103.562 81.8701 103.039 80.9994C102.519 80.1426 102.519 79.0679 103.039 78.2111C103.562 77.3404 103.838 76.3444 103.838 75.329Z",
    fill: "#88B337"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7105 66.7764H99.5614V93.8597H96.7105V66.7764Z",
    fill: "#A3603E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5662 36.8422H36.8425V39.693H32.5662V36.8422Z",
    fill: "#EF701B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9478 41.1184H58.2241V43.9693H53.9478V41.1184Z",
    fill: "#EF701B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1582 45.3948H92.4345V48.2457H88.1582V45.3948Z",
    fill: "#EF701B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6274 33.9912H72.4783V36.8421H69.6274V33.9912Z",
    fill: "#EF701B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.053 59.6492H75.3293V62.5H71.053V59.6492Z",
    fill: "#EF701B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.417 69.6272H38.2679V72.4781H35.417V69.6272Z",
    fill: "#EF701B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2021 73.9036H71.053V76.7544H68.2021V73.9036Z",
    fill: "#EF701B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1582 85.307H91.0091V88.1579H88.1582V85.307Z",
    fill: "#EF701B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9478 93.8596H56.7986V96.7105H53.9478V93.8596Z",
    fill: "#EF701B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2679 45.3948H42.5443V48.2457H38.2679V45.3948Z",
    fill: "#EF701B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1184 32.5658H49.671V46.8202H41.1184V32.5658Z",
    fill: "#A12A2A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1184 32.5658H49.671V39.693H41.1184V32.5658Z",
    fill: "#DEE1E3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1184 32.5658H49.671V35.4167H41.1184V32.5658Z",
    fill: "#C0C3C4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2236 32.5658H66.7763V46.8202H58.2236V32.5658Z",
    fill: "#A12A2A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2236 32.5658H66.7763V39.693H58.2236V32.5658Z",
    fill: "#DEE1E3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2236 32.5658H66.7763V35.4167H58.2236V32.5658Z",
    fill: "#C0C3C4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M75.329 32.5658H83.8816V46.8202H75.329V32.5658Z",
    fill: "#A12A2A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M75.329 32.5658H83.8816V39.693H75.329V32.5658Z",
    fill: "#DEE1E3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M75.329 32.5658H83.8816V35.4167H75.329V32.5658Z",
    fill: "#C0C3C4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1184 58.2236H49.671V72.478H41.1184V58.2236Z",
    fill: "#A12A2A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1184 58.2236H49.671V65.3508H41.1184V58.2236Z",
    fill: "#DEE1E3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1184 58.2236H49.671V61.0745H41.1184V58.2236Z",
    fill: "#C0C3C4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2236 58.2236H66.7763V72.478H58.2236V58.2236Z",
    fill: "#A12A2A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2236 58.2236H66.7763V65.3508H58.2236V58.2236Z",
    fill: "#DEE1E3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2236 58.2236H66.7763V61.0745H58.2236V58.2236Z",
    fill: "#C0C3C4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M75.329 58.2236H83.8816V72.478H75.329V58.2236Z",
    fill: "#A12A2A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M75.329 58.2236H83.8816V65.3508H75.329V58.2236Z",
    fill: "#DEE1E3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M75.329 58.2236H83.8816V61.0745H75.329V58.2236Z",
    fill: "#C0C3C4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1184 83.8816H49.671V98.136H41.1184V83.8816Z",
    fill: "#A12A2A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1184 83.8816H49.671V91.0088H41.1184V83.8816Z",
    fill: "#DEE1E3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1184 83.8816H49.671V86.7325H41.1184V83.8816Z",
    fill: "#C0C3C4"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2236 83.8816H66.7763V98.136H58.2236V83.8816Z",
    fill: "#A12A2A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2236 83.8816H66.7763V91.0088H58.2236V83.8816Z",
    fill: "#DEE1E3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2236 83.8816H66.7763V86.7325H58.2236V83.8816Z",
    fill: "#C0C3C4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M75.329 83.8816H83.8816V98.136H75.329V83.8816Z",
    fill: "#A12A2A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M75.329 83.8816H83.8816V86.7325H75.329V83.8816Z",
    fill: "#912626"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4781 98.136H86.7325V103.838H72.4781V98.136Z",
    fill: "#FF9747"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7368 102.412H105.263V105.263H19.7368V102.412Z",
    fill: "#C0C2C4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5658 22.5878H92.4342V25.4386H32.5658V22.5878Z",
    fill: "#EF701B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5658 28.2894H92.4342V31.1403H32.5658V28.2894Z",
    fill: "#EF701B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5658 53.9474H92.4342V56.7983H32.5658V53.9474Z",
    fill: "#EF701B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5658 79.6052H92.4342V82.4561H32.5658V79.6052Z",
    fill: "#EF701B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCond);
export default __webpack_public_path__ + "static/media/cond.a1c4ae9cff2c43825e7a3a8ee611e851.svg";
export { ForwardRef as ReactComponent };